export default {
  circle: {
    width: 40,
    height: 40,
    borderRadius: 20,
    marginRop: 4,
    cursor: 'pointer',
  },
  colorContainer: {
    position: 'absolute',
    right: 50,
    top: -75,
  },
  colorPaperContainer: {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  },
};

